'use strict';

var _ = require('lodash');
var DropdownValuesService = function DropdownValuesService() {
  /**
   * Check if only a given column has value
   *
   * @param {string} column
   * @param {Object} row
   * @param {Object} properties
   * @returns {boolean}
   */
  function isRowEmptyExceptColumn(column, row, properties) {
    return _.every(properties, function (property) {
      if (property === column) {
        return row[property] !== '';
      } else {
        return row[property] === '';
      }
    });
  }

  /**
   * Check if given value is matching data in row
   *
   * @param {string} column
   * @param {Object} value
   * @param {Object} row
   * @returns {boolean}
   */
  function isValueMatchingRow(column, value, row) {
    var matches = true;
    var properties = _.keys(value);
    if (isRowEmptyExceptColumn(column, row, properties)) {
      return true;
    }

    //commented out due to planned use searchCriteria in URD grid in future - dont forget about import searchCriteriaMatcherService
    // if (searchCriteriaMatcherService.match(column, value)) {
    _.forEach(properties, function (property) {
      matches = matches && (row[property] === value[property] || !row[property] && row.isNewlyAdded || row[property] === '' || property === column);
    });
    return matches;
    // } else {
    //     return false;
    // }
  }

  /**
   * Reduce values array to only items that are matching given row
   *
   * @param values
   * @param column
   * @param row
   * @returns {string[]}
   */
  function reduceValues(values, column, row) {
    return _.chain(values).reduce(function (result, value) {
      if (isValueMatchingRow(column, value, row)) {
        result.push(value[column]);
      }
      return result;
    }, []).uniq().compact().value();
  }
  function getValues(values, column, row, columnsSortingFunctions) {
    var emptyItem = '';
    var result = [emptyItem].concat(reduceValues(values, column, row));
    return _.has(columnsSortingFunctions, column) ? _.sortBy(result, columnsSortingFunctions[column]) : result;
  }
  function isLocalOrSignificantMarket(localOrSignificantMarkets, attributes) {
    return _.some(localOrSignificantMarkets, {
      origin: attributes.origin,
      destination: attributes.destination
    });
  }
  return {
    getValues: getValues,
    isLocalOrSignificantMarket: isLocalOrSignificantMarket
  };
};
DropdownValuesService.$inject = ['DropdownValuesSearchCriteriaMatcherService'];
module.exports = DropdownValuesService;